const GOOGLE_ANALYTICS_BASE_URI = 'https://www.google-analytics.com/collect';

/**
 * Отправка события в Google Analytics с помощью Measurement Protocol
 */
export const ga = (payload) => {
  const params = Object.entries({
    v: 1,
    tid: getGaTrackingId(),
    t: 'event',
    ...payload
  })
    .filter(([prop, val]) => !!val)
    .map(([prop, val]) => `${prop}=${encodeURIComponent(String(val))}`);

  fetch(`${GOOGLE_ANALYTICS_BASE_URI}?${params.join('&')}`, {method: 'post'})
    .catch(e => console.error('ERROR sending event to ga', e));
};

export const getGaClientId = () => {
  let clientId = null
  if (window.ga) {
    window.ga((tracker) => {
      clientId = tracker.get('clientId')
    })
  }

  return clientId
}

export const getGaTrackingId = () => {
  let trackingId = null
  if (window.ga) {
    window.ga((tracker) => {
      trackingId = tracker.get('trackingId')
    })
  }

  return trackingId
}



// WEBPACK FOOTER //
// ./src/scripts/analytics.js